import React, { Component, createRef } from 'react';
import { Form, Input, Modal, message, Spin } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import { accessTokenState, phoneState } from "../../atoms";
import withRecoil from '../../withRecoil';
import queryString from "query-string";
import api from '../../api/api/index';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function error(title, content) {
  Modal.error({ title, content });
}

class Setup1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: new Array(4).fill(""),
      isResendDisabled: false,
      resendTimer: 0,
      loading: false,
    };
    this.inputRefs = Array(4).fill().map(() => createRef());
  }

  handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[A-Za-z0-9]{0,1}$/.test(value)) {
      const otp = [...this.state.otp];
      otp[index] = value;
      this.setState({ otp });
      if (value !== "" && index < 3) this.inputRefs[index + 1].current.focus();
    }
  }

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && this.state.otp[index] === "" && index > 0) {
      this.inputRefs[index - 1].current.focus();
    }
  }

  handleSubmit = () => {
    const { t } = this.props;
    const otpValue = this.state.otp.join("").toLowerCase();
    if (otpValue.length === 4) {
      this.setState({ loading: true });

      const finalBody = {
        otp: otpValue,
        access_token: this.props.recoilStates.accessTokenState.state
      };

      fetch(`${api.main}/check_otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: queryString.stringify(finalBody)
      })
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then(res => {
          if (res.status !== 104) {
            error(t('common:error'), res.message);
          } else {
            this.props.tokenAction(this.props.token).then(_ => this.props.goToStep(2));
          }
        })
        .catch(() => {
          error(t('common:error'), t('setup1:tryAgain'));
        })
        .finally(() => this.setState({ loading: false }));
    } else {
      message.error(this.props.t('setup1:enterFullOtp'));
    }
  }

  handleResend = () => {
    const { t } = this.props;
    this.setState({ isResendDisabled: true, resendTimer: 30 });

    fetch(`${api.main}/forgot_otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: queryString.stringify({
        access_token: this.props.recoilStates.accessTokenState.state,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw new Error(err.message || t('setup1:genericError'));
          });
        }
        return response.json();
      })
      .then((res) => {
        if (res.status === 103) {
          message.info(t('setup1:alreadyVerified'));
          this.props.goToStep(2);
        } else if (res.status === 104) {
          message.success(res.message || t('setup1:resentSuccess'));
          const countdown = setInterval(() => {
            if (this.state.resendTimer === 0) {
              clearInterval(countdown);
              this.setState({ isResendDisabled: false });
            } else {
              this.setState((prev) => ({ resendTimer: prev.resendTimer - 1 }));
            }
          }, 1000);
        } else {
          throw new Error(res.message || t('setup1:unexpectedError'));
        }
      })
      .catch((err) => {
        console.error('Error in handleResend:', err.message);
        message.error(err.message || t('setup1:resentFailed'));
        this.setState({ isResendDisabled: false });
      });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div style={{ position: 'relative', marginBottom: '20px', textAlign: 'center', width: '100%' }}>
          <div className='spare'>
            <h2 style={{ textAlign: "center", margin: 0 }}>{t('setup1:title')}</h2>
            <p>
              {t('setup1:introLine1')}
              <br />
              {t('setup1:introLine2')}
            </p>
          </div>
        </div>

        {/* Phone Number Verification */}
        <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
          <Form className="otp-form">
            <div className="otp-inputs">
              {this.state.otp.map((value, index) => (
                <Form.Item key={index} noStyle>
                  <Input
                    type="text"
                    maxLength="1"
                    value={value}
                    onChange={(e) => this.handleChange(e, index)}
                    onKeyDown={(e) => this.handleKeyDown(e, index)}
                    ref={this.inputRefs[index]}
                    className="otp-input"
                  />
                </Form.Item>
              ))}
            </div>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "10px" }}>
              <button
                className="action-button btn"
                disabled={this.state.isResendDisabled}
                onClick={this.handleResend}
              >
                {this.state.isResendDisabled
                  ? t('setup1:resendIn', { seconds: this.state.resendTimer })
                  : t('setup1:resend')}
              </button>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <button
                  type="submit"
                  onClick={this.handleSubmit}
                  className="action-button btn"
                  disabled={this.state.loading}
                >
                  {t('setup1:submit')}
                </button>

                {this.state.loading && (
                  <Spin size="small" style={{ marginLeft: 10, color: "blue" }} />
                )}
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ tokenAction }, dispatch);

const mapStateToProps = (state) => ({
  token: state.token,
  profile: state.profile,
});

// Wrap with i18n
const TranslatedSetup1 = withTranslation(['setup1', 'common'])(Setup1);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withRecoil(TranslatedSetup1, [accessTokenState, phoneState])));
